// extracted by mini-css-extract-plugin
export default {"tabs":"tabs_tabs__QmxeF","tabList":"tabs_tabList__8Ux-Q","tabItem":"tabs_tabItem__wiYpN","active":"tabs_active__B5NPh","tabContent":"tabs_tabContent__EGpcV"};